import { LevelRow } from '../types/survey';

type Props = {
  rows: LevelRow[];
};

function isSuspicious(v: string) {
  if (!v) return false;

  const n = Number(v);

  return (
    Number.isFinite(n) &&
    (n > 10 || n < 0)
  );
}

export default function OCRErrorDashboard({
  rows
}: Props) {

  const issues: string[] = [];

  rows.forEach((row, i) => {

    if (isSuspicious(row.bs)) {
      issues.push(
        `Row ${i + 1}: BS ${row.bs} suspicious`
      );
    }

    if (isSuspicious(row.is)) {
      issues.push(
        `Row ${i + 1}: IS ${row.is} suspicious`
      );
    }

    if (isSuspicious(row.fs)) {
      issues.push(
        `Row ${i + 1}: FS ${row.fs} suspicious`
      );
    }

    if (
      row.chainage &&
      !/^(\d{1,4}\+\d{1,4}|\d+)$/.test(
        row.chainage
      )
    ) {
      issues.push(
        `Row ${i + 1}: Chainage format unusual`
      );
    }

    if (
      row.side &&
      !['LHS', 'RHS', 'Center'].includes(
        row.side
      )
    ) {
      issues.push(
        `Row ${i + 1}: Side value invalid`
      );
    }
  });

  if (issues.length === 0) {
    return (
      <div
        style={{
          border: '1px solid green',
          padding: '10px',
          marginTop: '10px'
        }}
      >
        ✓ No OCR issues detected
      </div>
    );
  }

  return (
    <div
      style={{
        border: '1px solid red',
        padding: '10px',
        marginTop: '10px'
      }}
    >
      <h3>OCR Review Dashboard</h3>

      {issues.map((issue, i) => (
        <div key={i}>
          ⚠ {issue}
        </div>
      ))}
    </div>
  );
}
